import { CommunitySignupForm } from './community-signup-form'
import { PremiumSection } from '../shared/PremiumSection'
import { PremiumHeading } from '../shared/PremiumHeading'
import { OAC } from '@/content/oac'

export function SignupFormSection() {
  return (
    <PremiumSection id="signup" containerClassName="max-w-4xl">
      <PremiumHeading as="h2">Build notes</PremiumHeading>
      <p className="mb-8 max-w-2xl leading-relaxed text-[#c3ccc7]">
        What I actually changed that week, what broke, and what I would do
        differently — the same material that ends up in {OAC.short} and in the
        sessions. No schedule, no sequence, no pitch.
      </p>

      <div className="max-w-2xl rounded-xl border border-[#232a26] bg-[#141817] p-6 md:p-8">
        <CommunitySignupForm />
      </div>
    </PremiumSection>
  )
}
